export const pixiState = {};
resetState();

export function resetState() {
  pixiState.app = null;
  pixiState.room = null;
  pixiState.self = null;
  pixiState.others = {};
}
